import { render, staticRenderFns } from "./page-user-info.vue?vue&type=template&id=4d7f99ec&"
import script from "./page-user-info.vue?vue&type=script&lang=ts&"
export * from "./page-user-info.vue?vue&type=script&lang=ts&"
import style0 from "./page-user-info.vue?vue&type=style&index=0&id=4d7f99ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./page-user-info.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports